import * as React from "react";
import {
    styled } from "../ui";
import UiDrawer from "../ui/Drawer";
import Toolbar from "../ui/Toolbar";
import List from "../ui/List";
// import Typography from "../ui/Typography";
//import ListItem from "../ui/ListItem";
import ListItemIcon from "../ui/ListItemIcon";
import ListItemText from "../ui/ListItemText";
import ChevronLeftIcon from "../ui/icons/ChevronLeft";
import {
  CartDets,
  isRoleAllowed,
  isOtherRoleAllowed,
  isFeatureAllowed,
  OTHER_ADMIN_RIGHTS,
  getAuthSession,
  printDebugLog,
  isEmpty
} from "../../constants/constant";
import { Grid, IconButton, ListItemButton, Tooltip } from "../ui";
import { sideBarNavItems } from "./sidebarNavItems";
import "./sidebar.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const drawerWidth = 270;

const Drawer = styled(UiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
	flexShrink: 0,
  "& .UiDrawer-paper": {
    position: "relative",
	height: "calc(100dvh - 56px)",
	maxHeight: "calc(100dvh - 56px)",
	marginTop: "56px",
	backgroundColor: theme.palette.primary.datagridrow,
	overflowX: "hidden",
	overflowY: "auto",
	WebkitOverflowScrolling: "touch",
	scrollbarWidth: "thin",
	scrollbarColor: "transparent transparent",
	"&::-webkit-scrollbar": {
	  width: "4px",
	},
	"&::-webkit-scrollbar-track": {
	  background: "transparent",
	},
	"&::-webkit-scrollbar-thumb": {
	  borderRadius: "999px",
	  backgroundColor: "transparent",
	},
	"&:hover": {
	  scrollbarColor: "rgba(56, 189, 248, 0.9) transparent",
	},
	"&:hover::-webkit-scrollbar-thumb, &:active::-webkit-scrollbar-thumb": {
	  backgroundColor: "rgba(56, 189, 248, 0.9)",
	},
	"&:hover::-webkit-scrollbar-thumb:hover": {
	  backgroundColor: "rgba(14, 165, 233, 1)",
	},
	[theme.breakpoints.up("sm")]: {
	  height: "calc(100dvh - 64px)",
	  maxHeight: "calc(100dvh - 64px)",
	  marginTop: "64px",
	},
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    boxSizing: "border-box",
    ...(!open && {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    }),
  },
}));

export default function Sidebar({ open, toggleDrawer, setComponentIndex }) {
  const storeCartType = useSelector(state => state.setCartTypeReducer.cartType);
  const storeActiveShopHash = useSelector(state => state.setActiveShopHashReducer.activeShopHash);
  const navigate = useNavigate();
  const activeChefValue = storeActiveShopHash?.isChef ?? getAuthSession().isChef;
  const isChefEnabled = Number(storeActiveShopHash?.cartType) === CartDets.Resto
    && (activeChefValue === true || activeChefValue === 'true' || activeChefValue === 1 || activeChefValue === '1');
  React.useEffect(() => {
    //SideBar
  }, [storeCartType, storeActiveShopHash]);

  const isSideBarRoleAllowed = (permission) => {
    if (isEmpty(permission)) return true;
    if (isOtherRoleAllowed(OTHER_ADMIN_RIGHTS)) return true;
    return isRoleAllowed(permission.feature, permission.action);
  }

  const isItemAvailableInCarts = (cartTypes = []) => {
    if (cartTypes.includes(CartDets.All)) {
      return true;
    }
    return cartTypes.includes(Number(storeCartType));
  }

  const renderSideNavItem = (item, index) => {
    //console.log("renderSideNavItem",item);
    if (
      isItemAvailableInCarts(item.cartTypes) && (!item.chefOnly || isChefEnabled)
      && isSideBarRoleAllowed(item.permission) && (isEmpty(item.feature) || isFeatureAllowed(item.feature))
    ) {
      return (
        <div key={index} style={{ justifyContent: "center", alignContent: "center", alignItems: "center" }}>
          <List >

            <ListItemButton sx={{
              '@media (max-width: 600px)': {
                justifyContent: 'center',
              },
              '& .UiTypography-root': {
                color: 'background.paper',
              },
            }} onClick={() => {
              setComponentIndex(-1);
              printDebugLog("sidebar", item.path);
              navigate(item.path);
            }}>
              <Tooltip title={item.title}>
                <ListItemIcon sx={{
                  '& .UiSvgIcon-root': {
                    minWidth: '56px',
                    color: 'white',
                  },
                  '& .UiSvgIcon-root:hover': {
                    minWidth: '56px',
                    color: 'blue',
                  },
                }}>
                  {item.icon}</ListItemIcon>
              </Tooltip>
              {
                open && <ListItemText primary={<>
                  <p style={{ margin: 0, padding: 0, whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{item.title}</p>
                </>} />
              }


            </ListItemButton>
          </List>

        </div>
      );
    }
  };
  return (
    <div style={{ alignItems: "center", flexShrink: 0 }}>
      <Drawer
        style={{ alignItems: "center" }}
        sx={{
          boxShadow: 12,
          '& .UiList-root': {
            backgroundColor: 'primary.datagridrow',
          },
          '& .UiList-root:hover': {
            backgroundColor: 'rgba(1, 51, 62, 0.8)',
            '& .UiTypography-root': {
              marginLeft: "10px",
            },
          },
        }}
        variant="permanent" open={open}>
        <Toolbar
          sx={{
            display: "none",
            alignItems: "center",
            justifyContent: "flex-end",
            px: [1],
            backgroundColor: "primary.datagridrow"
          }}
        >
          <Grid container spacing={1}
            alignItems="center" justifyContent="center" sx={{
              padding: 0.1, m: 0.5,
            }}>
            {/* {
              open && <Grid item md={6} lg={6} xs={6} sm={6}>
                <Typography variant="p" alignContent="center" justifyItems="center" color={"white"} style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word', fontSize:"14px" }}>
                  {storeActiveShopHash.shop}
                </Typography>
              </Grid>
            }  */}
            <Grid item md={6} lg={6} xs={6} sm={6}>
              <IconButton onClick={toggleDrawer}>
                <ChevronLeftIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Toolbar>
        {sideBarNavItems.map((item, index) => renderSideNavItem(item, index))}

      </Drawer>
    </div>
  );
}
